{
  "about.blocks": "Sirvidores moderaos",
  "about.contact": "Contautu:",
  "about.disclaimer": "Mastodon ye software gratuito y de códigu llibre, y una marca rexistrada de Mastodon gGmbH.",
  "about.domain_blocks.no_reason_available": "El motivu nun ta disponible",
  "about.domain_blocks.preamble": "Polo xeneral, Mastodon permítete ver el conteníu ya interactuar colos perfiles d'otros sirvidores nel fediversu. Estes son les esceiciones que se ficieron nesti sirvidor.",
  "about.domain_blocks.silenced.explanation": "Polo xeneral, nun ves los perfiles y el conteníu d'esti sirvidor sacante que los busques o decidas siguilos.",
  "about.domain_blocks.silenced.title": "Llendóse",
  "about.domain_blocks.suspended.explanation": "Nun se procesa, atroxa nin intercambia nengún datu d'esti sirvidor, lo que fai imposible cualesquier interaición o comunicación colos sos perfiles.",
  "about.domain_blocks.suspended.title": "Suspendióse",
  "about.not_available": "Esta información nun ta disponible nesti sirvidor.",
  "about.powered_by": "Una rede social descentralizada que tien la teunoloxía de {mastodon}",
  "about.rules": "Normes del sirvidor",
  "account.account_note_header": "Nota personal",
  "account.add_or_remove_from_list": "Amestar o quitar de les llistes",
  "account.badges.bot": "Automatizóse",
  "account.badges.group": "Grupu",
  "account.block": "Bloquiar a @{name}",
  "account.block_domain": "Bloquiar el dominiu {domain}",
  "account.block_short": "Bloquiar",
  "account.blocked": "Perfil bloquiáu",
  "account.copy": "Copiar l'enlllaz al perfil",
  "account.direct": "Mentar a @{name} per privao",
  "account.disable_notifications": "Dexar d'avisame cuando @{name} espublice artículos",
  "account.edit_profile": "Editar el perfil",
  "account.enable_notifications": "Avisame cuando @{name} espublice artículos",
  "account.endorse": "Destacar nel perfil",
  "account.follow": "Siguir",
  "account.follow_back": "Siguir tamién",
  "account.follow_request_short": "Solicitú",
  "account.followers": "Siguidores",
  "account.followers.empty": "Naide sigue a esti perfil.",
  "account.following": "Siguiendo",
  "account.follows.empty": "Esti perfil nun sigue a naide.",
  "account.go_to_profile": "Dir al perfil",
  "account.hide_reblogs": "Esconder los artículos compartíos de @{name}",
  "account.in_memoriam": "N'alcordanza.",
  "account.joined_short": "Data de xunión",
  "account.link_verified_on": "La propiedá d'esti enllaz comprobóse'l {date}",
  "account.media": "Multimedia",
  "account.mention": "Mentar a @{name}",
  "account.moved_to": "{name} indicó qu'agora la so cuenta nueva ye:",
  "account.mute": "Desactivar los avisos de @{name}",
  "account.mute_notifications_short": "Silenciar avisos",
  "account.mute_short": "Silenciar",
  "account.name.help.header": "Un \"handle\" ye como una dirección de corréu",
  "account.no_bio": "Nun se fornió nenguna descripción.",
  "account.open_original_page": "Abrir la páxina orixinal",
  "account.posts": "Artículos",
  "account.report": "Informar de @{name}",
  "account.requested_follow": "{name} solicitó siguite",
  "account.share": "Compartir el perfil de @{name}",
  "account.show_reblogs": "Amosar los artículos compartíos de @{name}",
  "account.unblock": "Desbloquiar a @{name}",
  "account.unblock_domain": "Desbloquiar el dominiu «{domain}»",
  "account.unblock_short": "Desbloquiar",
  "account.unendorse": "Dexar de destacar nel perfil",
  "account.unfollow": "Dexar de siguir",
  "account.unmute": "Activar los avisos de @{name}",
  "account.unmute_notifications_short": "Dexar de silenciar notificaciones",
  "account.unmute_short": "Activar los avisos",
  "account_edit.custom_fields.placeholder": "Añade los tos pronombres, enllaces externos o cualquier otra cosa que quieras compartir.",
  "account_edit.custom_fields.tip_title": "Conseyu: Añadir enllaces verificáos",
  "account_edit.display_name.title": "Nome a mostrar",
  "account_edit.field_edit_modal.name_hint": "Por exemplu: \"Web personal\"",
  "account_edit.profile_tab.hint.title": "Les visualizaciones sigan variando",
  "account_edit.verified_modal.details": "Añade credibilidá al to perfil de Mastodon verificando enllaces a webs personales. Asina ye como funciona:",
  "account_note.placeholder": "Calca equí p'amestar una nota",
  "admin.dashboard.retention.average": "Media",
  "admin.dashboard.retention.cohort": "Mes de rexistru",
  "admin.dashboard.retention.cohort_size": "Perfiles nuevos",
  "admin.impact_report.instance_followers": "Seguidores que perderíen los nuestros usuarios",
  "alert.rate_limited.message": "Volvi tentalo dempués de la hora: {retry_time, time, medium}.",
  "alert.unexpected.message": "Prodúxose un error inesperáu.",
  "alert.unexpected.title": "¡Meca!",
  "alt_text_badge.title": "Testu alternativu",
  "alt_text_modal.add_alt_text": "Amestar testu alternativu",
  "alt_text_modal.cancel": "Encaboxar",
  "alt_text_modal.done": "Fecho",
  "announcement.announcement": "Anunciu",
  "annual_report.summary.new_posts.new_posts": "artículos nuevos",
  "attachments_list.unprocessed": "(ensin procesar)",
  "block_modal.show_less": "Amosar menos",
  "block_modal.show_more": "Amosar más",
  "bundle_column_error.error.body": "La páxina solicitada nun se pudo renderizar. Ye posible que seya pola mor d'un fallu nel códigu o por un problema de compatibilidá del restolador.",
  "bundle_column_error.error.title": "¡Oh, non!",
  "bundle_column_error.network.body": "Hebo un error al tentar de cargar esta páxina. Esto pudo ser pola mor d'un problema temporal cola conexón a internet o con esti sirvidor.",
  "bundle_column_error.network.title": "Fallu de rede",
  "bundle_column_error.retry": "Retentar",
  "bundle_column_error.return": "Volver al aniciu",
  "bundle_column_error.routing.body": "Nun se pudo atopar la páxina solicitada. ¿De xuru que la URL de la barra de direiciones ta bien escrita?",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "Zarrar",
  "bundle_modal_error.retry": "Retentar",
  "closed_registrations.other_server_instructions": "Darréu que Mastodon ye una rede social descentralizada, pues crear una cuenta n'otru sirvidor y siguir interactuando con esti.",
  "closed_registrations_modal.description": "Anguaño nun ye posible crear cuentes en {domain}, mas ten en cuenta que nun precises una cuenta nesti sirvidor pa usar Mastodon.",
  "closed_registrations_modal.find_another_server": "Atopar otru sirvidor",
  "closed_registrations_modal.preamble": "Mastodon ye una rede social descentralizada polo que nun importa ónde crees la cuenta, vas ser a siguir ya interactuar con persones d'esti sirvidor. ¡Ya tamién pues tener el to propiu sirvidor!",
  "closed_registrations_modal.title": "Rexistru en Mastodon",
  "column.about": "Tocante a",
  "column.blocks": "Perfiles bloquiaos",
  "column.bookmarks": "Marcadores",
  "column.community": "Llinia de tiempu llocal",
  "column.create_list": "Crear llista",
  "column.direct": "Menciones privaes",
  "column.domain_blocks": "Dominios bloquiaos",
  "column.edit_list": "Editar la llista",
  "column.favourites": "Favoritos",
  "column.firehose": "Feed en direuto",
  "column.follow_requests": "Solicitúes de siguimientu",
  "column.home": "Aniciu",
  "column.lists": "Llistes",
  "column.mutes": "Perfiles colos avisos desactivaos",
  "column.notifications": "Avisos",
  "column.pins": "Artículos fixaos",
  "column.public": "Llinia de tiempu federada",
  "column_back_button.label": "Atrás",
  "column_header.moveLeft_settings": "Mover la columna a la esquierda",
  "column_header.moveRight_settings": "Mover la columna a la derecha",
  "column_header.pin": "Fixar",
  "column_header.show_settings": "Amosar la configuración",
  "column_header.unpin": "Lliberar",
  "column_search.cancel": "Encaboxar",
  "community.column_settings.media_only": "Namás el conteníu multimedia",
  "community.column_settings.remote_only": "Namás lo remoto",
  "compose.language.change": "Camudar la llingua",
  "compose.language.search": "Buscar llingües…",
  "compose.published.body": "Publicóse la publicación.",
  "compose.published.open": "Abrir",
  "compose.saved.body": "Guardóse la publicación.",
  "compose_form.direct_message_warning_learn_more": "Saber más",
  "compose_form.encryption_warning": "Los artículos de Mastodon nun tán cifraos de puntu a puntu. Nun compartas nengún tipu d'información sensible per Mastodon.",
  "compose_form.lock_disclaimer": "La to cuenta nun ye {locked}. Cualesquier perfil pue siguite pa ver los artículos que son namás pa siguidores.",
  "compose_form.lock_disclaimer.lock": "privada",
  "compose_form.placeholder": "¿En qué pienses?",
  "compose_form.poll.option_placeholder": "Opción {number}",
  "compose_form.poll.type": "Tipu",
  "compose_form.publish": "Espublizar",
  "compose_form.reply": "Responder",
  "confirmation_modal.cancel": "Encaboxar",
  "confirmations.block.confirm": "Bloquiar",
  "confirmations.delete.confirm": "Desaniciar",
  "confirmations.delete.message": "¿De xuru que quies desaniciar esta publicación?",
  "confirmations.delete.title": "¿Quies desaniciar esta publicación?",
  "confirmations.delete_list.confirm": "Desaniciar",
  "confirmations.delete_list.message": "¿De xuru que quies desaniciar permanentemente esta llista?",
  "confirmations.delete_list.title": "¿Quies desaniciar la llista?",
  "confirmations.discard_edit_media.confirm": "Escartar",
  "confirmations.follow_to_list.title": "¿Siguir al usuariu?",
  "confirmations.logout.confirm": "Zarrar la sesión",
  "confirmations.logout.message": "¿De xuru que quies zarrar la sesión?",
  "confirmations.logout.title": "¿Quies zarrar la sesión?",
  "confirmations.missing_alt_text.confirm": "Amestar testu alternativu",
  "confirmations.missing_alt_text.title": "¿Quies amestar testu alternativu?",
  "confirmations.redraft.confirm": "Desaniciar y reeditar",
  "confirmations.redraft.title": "¿Desaniciar y reeditar la publicación?",
  "confirmations.unfollow.confirm": "Dexar de siguir",
  "content_warning.hide": "Esconder la publicación",
  "content_warning.show": "Amosar de toes toes",
  "content_warning.show_more": "Amosar más",
  "conversation.delete": "Desaniciar la conversación",
  "conversation.mark_as_read": "Marcar como lleíu",
  "conversation.open": "Ver la conversación",
  "conversation.with": "Con {names}",
  "copy_icon_button.copied": "Copiáu nel cartafueyu",
  "copypaste.copied": "Copióse",
  "copypaste.copy_to_clipboard": "Copiar nel cartafueyu",
  "directory.federated": "Del fediversu conocíu",
  "directory.local": "De «{domain}» namás",
  "directory.new_arrivals": "Cuentes nueves",
  "directory.recently_active": "Con actividá recién",
  "disabled_account_banner.account_settings": "Axustes de la cuenta",
  "dismissable_banner.community_timeline": "Esta seición contién los artículos públicos más actuales de los perfiles agospiaos nel dominiu {domain}.",
  "dismissable_banner.dismiss": "Escartar",
  "domain_block_modal.block": "Bloquiar el sirvidor",
  "domain_block_modal.they_cant_follow": "Naide d'esti sirvidor pue siguite.",
  "domain_block_modal.title": "Bloquiar el dominiu?",
  "domain_pill.server": "Sirvidor",
  "domain_pill.username": "Nome d'usuariu",
  "embed.instructions": "Empotra esta publicación nel to sitiu web copiando'l códigu d'abaxo.",
  "embed.preview": "Va apaecer asina:",
  "emoji_button.activity": "Actividá",
  "emoji_button.flags": "Banderes",
  "emoji_button.food": "Comida y bébora",
  "emoji_button.nature": "Natura",
  "emoji_button.not_found": "Nun s'atoparon fustaxes que concasen",
  "emoji_button.objects": "Oxetos",
  "emoji_button.people": "Persones",
  "emoji_button.recent": "D'usu frecuente",
  "emoji_button.search": "Buscar…",
  "emoji_button.search_results": "Resultaos de la busca",
  "emoji_button.symbols": "Símbolos",
  "emoji_button.travel": "Viaxes y llugares",
  "empty_column.account_suspended": "Cuenta suspendida",
  "empty_column.account_timeline": "¡Equí nun hai nenguna publicación!",
  "empty_column.blocks": "Nun bloquiesti a nengún perfil.",
  "empty_column.bookmarked_statuses": "Nun tienes nenguna publicación en Marcadores. Cuando amiestes dalguna, va apaecer equí.",
  "empty_column.direct": "Nun tienes nenguna mención privada. Cuando unvies o recibas dalguna, apaez equí.",
  "empty_column.domain_blocks": "Nun hai nengún dominiu bloquiáu.",
  "empty_column.explore_statuses": "Agora nun hai nada en tendencia. ¡Volvi equí dempués!",
  "empty_column.follow_requests": "Nun tienes nenguna solicitú de siguimientu. Cuando recibas dalguna, apaez equí.",
  "empty_column.hashtag": "Entá nun hai nada con esta etiqueta.",
  "empty_column.home": "¡La to llinia de tiempu ta balera! Sigui a cuentes pa enllenala.",
  "empty_column.list": "Nun hai nada nesta llista. Cuando los perfiles d'esta llista espublicen artículos nuevos, apaecen equí.",
  "empty_column.mutes": "Nun tienes nengún perfil colos avisos desactivaos.",
  "empty_column.notifications": "Nun tienes nengún avisu. Cuando otros perfiles interactúen contigo, apaez equí.",
  "empty_column.public": "¡Equí nun hai nada! Escribi daqué públicamente o sigui a perfiles d'otros sirvidores pa enllenar esta seición",
  "error.unexpected_crash.explanation": "Pola mor d'un fallu nel códigu o un problema de compatibilidá del restolador, esta páxina nun se pudo amosar correutamente.",
  "error.unexpected_crash.explanation_addons": "Esta páxina nun se pudo amosar correutamente. Ye probable que dalgún complementu del restolador o dalguna ferramienta de traducción automática produxere esti error.",
  "error.unexpected_crash.next_steps": "Prueba a anovar la páxina. Si nun sirve, ye posible que tovía seyas a usar Mastodon pente otru restolador o una aplicación nativa.",
  "error.unexpected_crash.next_steps_addons": "Prueba a desactivalos y a anovar la páxina. Si nun sirve, ye posible que tovía seyas a usar Mastodon pente otru restolador o una aplicación nativa.",
  "explore.suggested_follows": "Perfiles",
  "explore.trending_links": "Noticies",
  "explore.trending_statuses": "Artículos",
  "explore.trending_tags": "Etiquetes",
  "filter_modal.added.context_mismatch_explanation": "Esta categoría de peñera nun s'aplica al contestu nel qu'accediesti a esta publicación. Si tamién quies que se peñere la publicación nesti contestu, tienes d'editar la peñera.",
  "filter_modal.added.context_mismatch_title": "¡El contestu nun coincide!",
  "filter_modal.added.expired_explanation": "Esta categoría de peñera caducó, tienes de camudar la so data de caducidá p'aplicala.",
  "filter_modal.added.expired_title": "¡La peñera caducó!",
  "filter_modal.added.review_and_configure": "Pa revisar y configurar a fondu esta categoría de peñera, vete a la {settings_link}.",
  "filter_modal.added.review_and_configure_title": "Configuración de la peñera",
  "filter_modal.added.settings_link": "páxina de configuración",
  "filter_modal.added.short_explanation": "Esta publicación amestóse a la categoría de peñera siguiente: {title}.",
  "filter_modal.added.title": "¡Amestóse la peñera!",
  "filter_modal.select_filter.expired": "caducó",
  "filter_modal.select_filter.prompt_new": "Categoría nueva: {name}",
  "filter_modal.select_filter.search": "Buscar o crear",
  "filter_modal.select_filter.subtitle": "Usa una categoría esistente o créala",
  "filter_modal.select_filter.title": "Peñerar esta publicación",
  "filter_modal.title.status": "Peñera d'una publicación",
  "firehose.all": "Tolos sirvidores",
  "firehose.local": "Esti sirvidor",
  "firehose.remote": "Otros sirvidores",
  "follow_request.authorize": "Autorizar",
  "follow_request.reject": "Refugar",
  "follow_requests.unlocked_explanation": "Magar que la to cuenta nun seya privada, el personal del dominiu «{domain}» pensó qu'a lo meyor quies revisar manualmente les solicitúes de siguimientu d'estes cuentes.",
  "follow_suggestions.dismiss": "Nun volver amosar",
  "follow_suggestions.friends_of_friends_longer": "Ye popular ente los perfiles que sigues",
  "follow_suggestions.personalized_suggestion": "Suxerencia personalizada",
  "follow_suggestions.popular_suggestion": "Suxerencia popular",
  "follow_suggestions.popular_suggestion_longer": "Ye popular na instancia {domain}",
  "follow_suggestions.similar_to_recently_followed_longer": "Aseméyase a los perfiles que siguiesti apocayá",
  "follow_suggestions.view_all": "Ver too",
  "follow_suggestions.who_to_follow": "A quién siguir",
  "followed_tags": "Etiquetes siguíes",
  "footer.about": "Tocante a",
  "footer.directory": "Direutoriu de perfiles",
  "footer.get_app": "Consiguir l'aplicación",
  "footer.keyboard_shortcuts": "Atayos del tecláu",
  "footer.privacy_policy": "Política de privacidá",
  "footer.source_code": "Ver el códigu fonte",
  "footer.status": "Estáu",
  "footer.terms_of_service": "Términos del serviciu",
  "generic.saved": "Guardóse",
  "getting_started.heading": "Comienzu",
  "hashtag.column_header.tag_mode.all": "y {additional}",
  "hashtag.column_header.tag_mode.any": "o {additional}",
  "hashtag.column_header.tag_mode.none": "ensin {additional}",
  "hashtag.column_settings.select.no_options_message": "Nun s'atopó nenguna suxerencia",
  "hashtag.column_settings.select.placeholder": "Introduz etiquetes…",
  "hashtag.column_settings.tag_mode.all": "Toes estes",
  "hashtag.column_settings.tag_mode.any": "Cualesquiera d'estes",
  "hashtag.column_settings.tag_mode.none": "Nenguna d'estes",
  "hashtag.counter_by_accounts": "{count, plural, one {{counter} participante} other {{counter} participantes}}",
  "hashtag.follow": "Siguir a la etiqueta",
  "hashtag.unfollow": "Dexar de siguir a la etiqueta",
  "home.column_settings.show_reblogs": "Amosar los artículos compartíos",
  "home.column_settings.show_replies": "Amosar les rempuestes",
  "home.pending_critical_update.body": "¡Anueva'l sirvidor de Mastodon namás que puedas!",
  "home.show_announcements": "Amosar anuncios",
  "info_button.label": "Ayuda",
  "interaction_modal.go": "Dir",
  "interaction_modal.no_account_yet": "¿Tovía nun tienes una cuenta?",
  "interaction_modal.on_another_server": "N'otru sirvidor",
  "interaction_modal.on_this_server": "Nesti sirvidor",
  "intervals.full.days": "{number, plural, one {# día} other {# díes}}",
  "intervals.full.hours": "{number, plural, one {# hora} other {# hores}}",
  "intervals.full.minutes": "{number, plural, one {# minutu} other {# minutos}}",
  "keyboard_shortcuts.back": "Dir p'atrás",
  "keyboard_shortcuts.blocked": "Abrir la llista de perfiles bloquiaos",
  "keyboard_shortcuts.boost": "Compartir una publicación",
  "keyboard_shortcuts.column": "Enfocar una columna",
  "keyboard_shortcuts.compose": "Enfocar l'área de composición",
  "keyboard_shortcuts.description": "Descripción",
  "keyboard_shortcuts.down": "Baxar na llista",
  "keyboard_shortcuts.enter": "Abrir una publicación",
  "keyboard_shortcuts.federated": "Abrir la llinia de tiempu federada",
  "keyboard_shortcuts.heading": "Atayos del tecláu",
  "keyboard_shortcuts.home": "Abrir la llinia de tiempu del aniciu",
  "keyboard_shortcuts.hotkey": "Atayu",
  "keyboard_shortcuts.legend": "Amosar esta lleenda",
  "keyboard_shortcuts.local": "Abrir la llinia de tiempu llocal",
  "keyboard_shortcuts.mention": "Mentar al autor/a",
  "keyboard_shortcuts.muted": "Abrir la llista de perfiles colos avisos desactivaos",
  "keyboard_shortcuts.my_profile": "Abrir el to perfil",
  "keyboard_shortcuts.notifications": "Abrir la columna d'avisos",
  "keyboard_shortcuts.open_media": "Abrir el conteníu mutimedia",
  "keyboard_shortcuts.pinned": "Abrir la llista d'artículos fixaos",
  "keyboard_shortcuts.profile": "Abrir el perfil del autor/a",
  "keyboard_shortcuts.reply": "Responder a una publicación",
  "keyboard_shortcuts.requests": "Abrir la llista de solicitúes de siguimientu",
  "keyboard_shortcuts.search": "Enfocar la barra de busca",
  "keyboard_shortcuts.start": "Abrir la columna «Entamar»",
  "keyboard_shortcuts.toggle_sensitivity": "Amosar/esconder el conteníu multimedia",
  "keyboard_shortcuts.toot": "Escribir una publicación nueva",
  "keyboard_shortcuts.unfocus": "Desenfocar l'área de composición/busca",
  "keyboard_shortcuts.up": "Xubir na llista",
  "lightbox.close": "Zarrar",
  "lightbox.next": "Siguiente",
  "limited_account_hint.action": "Amosar el perfil de toes toes",
  "link_preview.author": "Por {name}",
  "link_preview.more_from_author": "Más de {name}",
  "lists.add_member": "Amestar",
  "lists.add_to_list": "Amestar a la llista",
  "lists.add_to_lists": "Amestar {name} a la llista",
  "lists.create": "Crear",
  "lists.create_list": "Crear llista",
  "lists.delete": "Desaniciar la llista",
  "lists.done": "Fecho",
  "lists.edit": "Editar la llista",
  "lists.list_name": "Nome de la llista",
  "lists.no_lists_yet": "Ensin llistes tovía.",
  "lists.replies_policy.followed": "Cualesquier perfil siguíu",
  "lists.replies_policy.list": "Perfiles de la llista",
  "lists.replies_policy.none": "Naide",
  "lists.save": "Guardar",
  "lists.search": "Buscar",
  "load_pending": "{count, plural, one {# elementu nuevu} other {# elementos nuevos}}",
  "loading_indicator.label": "Cargando…",
  "navigation_bar.about": "Tocante a",
  "navigation_bar.blocks": "Perfiles bloquiaos",
  "navigation_bar.bookmarks": "Marcadores",
  "navigation_bar.direct": "Menciones privaes",
  "navigation_bar.domain_blocks": "Dominios bloquiaos",
  "navigation_bar.favourites": "Favoritos",
  "navigation_bar.filters": "Pallabres desactivaes",
  "navigation_bar.follow_requests": "Solicitúes de siguimientu",
  "navigation_bar.followed_tags": "Etiquetes siguíes",
  "navigation_bar.follows_and_followers": "Perfiles que sigues y te siguen",
  "navigation_bar.lists": "Llistes",
  "navigation_bar.logout": "Zarrar la sesión",
  "navigation_bar.moderation": "Moderación",
  "navigation_bar.mutes": "Perfiles colos avisos desactivaos",
  "navigation_bar.opened_in_classic_interface": "Los artículos, les cuentes y otres páxines específiques ábrense por defeutu na interfaz web clásica.",
  "navigation_bar.preferences": "Preferencies",
  "not_signed_in_indicator.not_signed_in": "Tienes d'aniciar la sesión p'acceder a esti recursu.",
  "notification.admin.report": "{name} informó de: {target}",
  "notification.admin.sign_up": "{name} rexistróse",
  "notification.follow": "{name} siguióte",
  "notification.follow_request": "{name} solicitó siguite",
  "notification.label.mention": "Mención",
  "notification.label.private_mention": "Mención privada",
  "notification.label.private_reply": "Rempuesta privada",
  "notification.label.reply": "Responder",
  "notification.mention": "Mención",
  "notification.mentioned_you": "{name} mentóte",
  "notification.moderation-warning.learn_more": "Deprender más",
  "notification.poll": "Finó una encuesta na que votesti",
  "notification.reblog": "{name} compartió la to publicación",
  "notification.status": "{name} ta acabante d'espublizar",
  "notification.update": "{name} editó una publicación",
  "notification_requests.edit_selection": "Editar",
  "notification_requests.exit_selection": "Fecho",
  "notifications.clear": "Borrar los avisos",
  "notifications.column_settings.admin.report": "Informes nuevos:",
  "notifications.column_settings.admin.sign_up": "Rexistros nuevos:",
  "notifications.column_settings.favourite": "Favoritos:",
  "notifications.column_settings.filter_bar.advanced": "Amosar toles categoríes",
  "notifications.column_settings.follow": "Siguidores nuevos:",
  "notifications.column_settings.follow_request": "Solicitúes de siguimientu nueves:",
  "notifications.column_settings.group": "Agrupar",
  "notifications.column_settings.mention": "Menciones:",
  "notifications.column_settings.poll": "Resultaos de les encuestes:",
  "notifications.column_settings.reblog": "Artículos compartíos:",
  "notifications.column_settings.show": "Amosar en columna",
  "notifications.column_settings.sound": "Reproducir un soníu",
  "notifications.column_settings.status": "Artículos nuevos:",
  "notifications.column_settings.unread_notifications.category": "Avisos ensin lleer",
  "notifications.column_settings.unread_notifications.highlight": "Rescamplar los avisos ensin lleer",
  "notifications.column_settings.update": "Ediciones:",
  "notifications.filter.all": "Too",
  "notifications.filter.favourites": "Favoritos",
  "notifications.filter.mentions": "Menciones",
  "notifications.filter.polls": "Resultaos de la encuesta",
  "notifications.group": "{count} avisos",
  "notifications.mark_as_read": "Marcar tolos avisos como lleíos",
  "notifications.permission_required": "Los avisos d'escritoriu nun tán disponibles porque nun se concedió'l permisu riquíu.",
  "notifications.policy.accept": "Aceptar",
  "notifications.policy.accept_hint": "Amosar n'avisos",
  "onboarding.profile.note": "Biografía",
  "onboarding.profile.note_hint": "Pues @mentar a otros perfiles o poner #etiquetes…",
  "password_confirmation.exceeds_maxlength": "La contraseña de confirmación supera la llongura de caráuteres máxima",
  "password_confirmation.mismatching": "La contraseña de confirmación nun concasa",
  "poll.closed": "Finó",
  "poll.refresh": "Anovar",
  "poll.reveal": "Ver los resultaos",
  "poll.total_people": "{count, plural, one {# persona} other {# persones}}",
  "poll.total_votes": "{count, plural, one {# votu} other {# votos}}",
  "poll.votes": "{votes, plural, one {# votu} other {# votos}}",
  "poll_button.add_poll": "Amestar una encuesta",
  "poll_button.remove_poll": "Quitar la encuesta",
  "privacy.change": "Configurar la privacidá de la publicación",
  "privacy.direct.short": "Mención privada",
  "privacy.private.short": "Siguidores",
  "privacy.public.short": "Publicación pública",
  "privacy_policy.last_updated": "Data del últimu anovamientu: {date}",
  "privacy_policy.title": "Política de privacidá",
  "refresh": "Anovar",
  "relative_time.days": "{number} d",
  "relative_time.full.days": "hai {number, plural, one {# día} other {# díes}}",
  "relative_time.full.hours": "hai {number, plural, one {# hora} other {# hores}}",
  "relative_time.full.just_now": "puramente agora",
  "relative_time.full.minutes": "hai {number, plural, one {# minutu} other {# minutos}}",
  "relative_time.full.seconds": "hai {number, plural, one {# segundu} other {# segundos}}",
  "relative_time.hours": "{number} h",
  "relative_time.just_now": "agora",
  "relative_time.minutes": "{number} m",
  "relative_time.seconds": "{number} s",
  "relative_time.today": "güei",
  "reply_indicator.cancel": "Encaboxar",
  "reply_indicator.poll": "Encuesta",
  "report.block": "Bloquiar",
  "report.categories.legal": "Llegal",
  "report.categories.spam": "Spam",
  "report.categories.violation": "El conteníu incumple una o más normes del sirvidor",
  "report.category.subtitle": "Escueyi la meyor opción",
  "report.category.title": "Dinos qué pasa con esti {type}",
  "report.category.title_account": "perfil",
  "report.category.title_status": "publicación",
  "report.close": "Fecho",
  "report.comment.title": "¿Hai daqué más qu'habríemos saber?",
  "report.forward": "Reunviar a {target}",
  "report.forward_hint": "La cuenta ye d'otru sirvidor. ¿Quies unviar a esi sirvidor una copia anónima del informe?",
  "report.mute": "Desactivar los avisos",
  "report.next": "Siguiente",
  "report.placeholder": "Comentarios adicionales",
  "report.reasons.dislike": "Nun me presta",
  "report.reasons.dislike_description": "Nun ye daqué que quiera ver",
  "report.reasons.legal": "Ye illegal",
  "report.reasons.other": "Ye daqué más",
  "report.reasons.other_description": "La incidencia nun s'axusta a les demás categoríes",
  "report.reasons.spam": "Ye spam",
  "report.reasons.spam_description": "Contién enllaces maliciosos, conteníu fraudulentu o rempuestes repetitives",
  "report.reasons.violation": "Incumple les normes del sirvidor",
  "report.reasons.violation_description": "Yes consciente qu'incumple dalguna norma específica",
  "report.rules.subtitle": "Seleiciona tolo que s'axuste",
  "report.rules.title": "¿Qué normes s'incumplen?",
  "report.statuses.subtitle": "Seleiciona tolo que s'axuste",
  "report.statuses.title": "¿Hai dalguna publicación qu'apoye esti informe?",
  "report.submit": "Unviar",
  "report.target": "Informe de: {target}",
  "report.thanks.take_action": "Equí tienes les opciones pa controlar qué ves en Mastodon:",
  "report.thanks.take_action_actionable": "Mentanto revisamos esti informe, pues tomar midíes contra @{name}:",
  "report.thanks.title": "¿Nun quies ver esti conteníu?",
  "report.thanks.title_actionable": "Gracies pol informe, el casu yá ta n'investigación.",
  "report.unfollow": "Dexar de siguir a @{name}",
  "report.unfollow_explanation": "Sigues a esta cuenta. Pa dexar de ver los sos artículos nel to feed d'aniciu, dexa de siguila.",
  "report_notification.attached_statuses": "{count, plural, one {Axuntóse {count} publicación} other {Axuntáronse {count} publicaciones}}",
  "report_notification.categories.legal": "Llegal",
  "report_notification.categories.legal_sentence": "conteníu illegal",
  "report_notification.categories.spam": "Spam",
  "report_notification.categories.spam_sentence": "spam",
  "report_notification.open": "Abrir l'informe",
  "search.no_recent_searches": "Nun hai nenguna busca recién",
  "search.placeholder": "Buscar",
  "search.quick_action.account_search": "Perfiles que concasen con {x}",
  "search.quick_action.go_to_account": "Dir al perfil {x}",
  "search.quick_action.go_to_hashtag": "Dir a la etiqueta {x}",
  "search.quick_action.status_search": "Artículos que concasen con {x}",
  "search.search_or_paste": "Busca o apiega una URL",
  "search_popout.full_text_search_disabled_message": "Nun ta disponible nel dominiu {domain}.",
  "search_popout.language_code": "códigu de llingua ISO",
  "search_popout.options": "Opciones de busca",
  "search_popout.quick_actions": "Aiciones rápides",
  "search_popout.recent": "Busques de recién",
  "search_popout.specific_date": "data específica",
  "search_popout.user": "perfil",
  "search_results.accounts": "Perfiles",
  "search_results.all": "Too",
  "search_results.hashtags": "Etiquetes",
  "search_results.see_all": "Ver too",
  "search_results.statuses": "Artículos",
  "server_banner.is_one_of_many": "{domain} ye unu de los munchos sirvidores independientes de Mastodon que pues usar pa participar nel fediversu.",
  "server_banner.server_stats": "Estadístiques del sirvidor:",
  "sign_in_banner.create_account": "Crear una cuenta",
  "sign_in_banner.mastodon_is": "Mastodon ye la meyor manera de siguir al momentu qué pasa.",
  "sign_in_banner.sign_in": "Aniciar la sesión",
  "sign_in_banner.sso_redirect": "Aniciar la sesión o rexistrase",
  "status.admin_account": "Abrir la interfaz de moderación pa @{name}",
  "status.admin_domain": "Abrir la interfaz de moderación pa «{domain}»",
  "status.admin_status": "Abrir esta publicación na interfaz de moderación",
  "status.block": "Bloquiar a @{name}",
  "status.bookmark": "Meter en Marcadores",
  "status.cannot_reblog": "Esta publicación nun se pue compartir",
  "status.copy": "Copiar l'enllaz a la publicación",
  "status.delete": "Desaniciar",
  "status.direct": "Mentar a @{name} per privao",
  "status.direct_indicator": "Mención privada",
  "status.edited_x_times": "Editóse {count, plural, one {{count} vegada} other {{count} vegaes}}",
  "status.embed": "Consiguir el códigu pa empotrar",
  "status.filter": "Peñerar esta publicación",
  "status.history.created": "{name} creó {date}",
  "status.history.edited": "{name} editó {date}",
  "status.load_more": "Cargar más",
  "status.media_hidden": "Conteníu multimedia escondíu",
  "status.mention": "Mentar a @{name}",
  "status.more": "Más",
  "status.mute": "Desactivar los avisos de @{name}",
  "status.mute_conversation": "Desactivar los avisos de la conversación",
  "status.open": "Espander esta publicación",
  "status.pin": "Fixar nel perfil",
  "status.read_more": "Lleer más",
  "status.reblog": "Compartir",
  "status.reblogged_by": "{name} compartió",
  "status.reblogs.empty": "Naide nun compartió esta publicación. Cuando daquién lo faiga, va apaecer equí.",
  "status.redraft": "Desaniciar y reeditar",
  "status.remove_bookmark": "Desaniciar el marcador",
  "status.replied_to": "En rempuesta a {name}",
  "status.reply": "Responder",
  "status.replyAll": "Responder al filu",
  "status.report": "Informar de @{name}",
  "status.sensitive_warning": "Conteníu sensible",
  "status.share": "Compartir",
  "status.show_original": "Amosar l'orixinal",
  "status.translate": "Traducir",
  "status.translated_from_with": "Tradúxose del {lang} con {provider}",
  "status.uncached_media_warning": "La previsualización nun ta disponible",
  "status.unmute_conversation": "Activar los avisos de la conversación",
  "status.unpin": "Lliberar del perfil",
  "subscribed_languages.save": "Guardar los cambeos",
  "tabs_bar.home": "Aniciu",
  "tabs_bar.menu": "Menú",
  "tabs_bar.notifications": "Avisos",
  "terms_of_service.title": "Términos del serviciu",
  "time_remaining.days": "{number, plural, one {Queda # día} other {Queden # díes}}",
  "time_remaining.hours": "{number, plural, one {Queda # hora} other {Queden # hores}}",
  "time_remaining.minutes": "{number, plural, one {Queda # minutu} other {Queden # minutos}}",
  "time_remaining.seconds": "{number, plural, one {Queda # segundu} other {Queden # segundos}}",
  "trends.counter_by_accounts": "{count, plural, one {{counter} persona} other {{counter} persones}} {days, plural, one {nel últimu día} other {nos últimos {days} díes}}",
  "trends.trending_now": "En tendencia",
  "ui.beforeunload": "El borrador piérdese si coles de Mastodon.",
  "units.short.billion": "{count} MM",
  "units.short.million": "{count} M",
  "units.short.thousand": "{count} mil",
  "upload_area.title": "Arrastra y suelta pa xubir",
  "upload_button.label": "Amestar ficheros multimedia",
  "upload_error.poll": "La xuba de ficheros nun ta permitida coles encuestes.",
  "upload_form.edit": "Editar",
  "upload_progress.label": "Xubiendo…",
  "upload_progress.processing": "Procesando…",
  "video.close": "Zarrar el videu",
  "video.download": "Baxar el ficheru",
  "video.exit_fullscreen": "Colar de la pantalla completa",
  "video.expand": "Espander el videu",
  "video.fullscreen": "Pantalla completa",
  "video.hide": "Esconder el videu",
  "video.pause": "Posar",
  "video.play": "Reproducir"
}
